import { Grid, MenuItem, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { createMessage, editMessage, getDrafts, getRecipients } from "../../actions/messageCenterActions";
import { getUserPreference } from "../../utilities/common";
import UniDialog from "../Common/UniDialog";
import _ from 'lodash';
import FullscreenLoading from "../Common/FullscreenLoading";
import { useToken } from "../../utilities/hooks";
import { showAlertSnackbar } from "../../reducers/uiSlice";


function MessageDetail(props) {
    const {t} = useTranslation('messageCenter');
    const dispatch = useDispatch();
    const userPref = getUserPreference();
    const tokenContents = useToken();

    const warehouses = tokenContents.warehouse;

    const messageTypes = useSelector(state => state.messageCenterReducer.getMessageTypes);
    const recipientGroup = useSelector(state => state.messageCenterReducer.getRecipientGroup);
    const recipientsAll = useSelector(state => state.messageCenterReducer.getRecipientsAll);
    const prompList = useSelector(state => state.messageCenterReducer.getDisableOption);

    const PARAMS_INIT = {
        message_type: 2,
        effective_from: moment().format('YYYY-MM-DD HH:mm:ss'),
        effective_to: moment().add(7, 'd').format('YYYY-MM-DD HH:mm:ss'),
        recipient_type: 1,
        recipient: [],
        prompts_mode: 1,
        title: '',
        content: '',
        warehouse_id: userPref.userCity,
        creator: userPref.username
    }

    const RECIPIENTS_INIT = {
        code: 0,
        name: t('common:all')
    };

    const PARAMS_PUBLISH = {
        status: 'PUBLISHED',
        operator: userPref.username
    }

    const [params, setParams] = useState(PARAMS_INIT);
    const [recipientType, setRecipientType] = useState({id:'1',isInitialEdit:false}); // 0 => all
    const [recipients, setRecipients] = useState(recipientsAll);
    const [recipientsSelected, setRecipientsSelected] = useState([]);
    const [loading, setLoading] = useState(false);


    const handleCreatePublish = async(paramsModify) => {
        try {
            const res = await dispatch(createMessage(paramsModify, userPref.userCity));
            await dispatch(editMessage(res.message_id, PARAMS_PUBLISH, userPref.userCity));
            if(props.messageGeneralType === 'drafts') {
                await dispatch(getDrafts({warehouse: userPref.userCity}));
            }
            await dispatch(showAlertSnackbar({ message: t('publish_success'), type: 'success' }))
            await props.onClose();
        } catch {
            dispatch(showAlertSnackbar({ message: t('publish_fail'), type: 'error' }))
        }
    }

    const handleCreate = async(paramsModify) => {
        try {
            await dispatch(createMessage(paramsModify, userPref.userCity));
            if(props.messageGeneralType === 'drafts') {
                await dispatch(getDrafts({warehouse: userPref.userCity}));
            }
            await dispatch(showAlertSnackbar({ message: t('create_or_edit_success'), type: 'success' }))
            await props.onClose();
        } catch {
            dispatch(showAlertSnackbar({ message: t('create_or_edit_fail'), type: 'error' }))
        }
    }

    const handleEditPublish = async(paramsModify) => {
        try {
            await dispatch(editMessage(paramsModify.id, paramsModify, userPref.userCity))
            await dispatch(editMessage(paramsModify.id, PARAMS_PUBLISH, userPref.userCity))
            if(props.messageGeneralType === 'drafts') {
                await dispatch(getDrafts({warehouse: userPref.userCity}))
            }
            await dispatch(showAlertSnackbar({ message: t('publish_success'), type: 'success' }))
            await props.onClose();
        } catch {
            dispatch(showAlertSnackbar({ message: t('publish_fail'), type: 'error' }))
        }
    }

    const handleEdit = async(paramsModify) => {
        try {
            await dispatch(editMessage(paramsModify.id, paramsModify, userPref.userCity));
            if(props.messageGeneralType === 'drafts') {
                await dispatch(getDrafts({warehouse: userPref.userCity}))
            }
            await dispatch(showAlertSnackbar({ message: t('create_or_edit_success'), type: 'success' }))
            await props.onClose();
        // error and finally are managed in handleUpdate().
        } catch {
            dispatch(showAlertSnackbar({ message: t('create_or_edit_fail'), type: 'error' }))
        }
    }

    const handleUpdate = async(type) => {
        try {
            let paramsModify = {};
            for (const key in params) {
                if(key === 'recipient' || key === 'recipients') {
                    const value = _.map(recipientsSelected, 'code');
                    if(recipientType.id === '1' && value.toString() === '0') {
                        let recipientsClone = [...recipients];
                        // Delete {code:0,name:all}
                        recipientsClone.shift();
                        paramsModify['recipient'] = _.map(recipientsClone, 'code');
                    } else {
                        paramsModify['recipient'] = value;
                    }
                } else {
                    if(key !== 'unreadDetail' && key !== 'unread' && key !== 'total') {
                        paramsModify[key] = params[key];
                    }
                }
            }
            paramsModify['recipient_type'] = recipientType.id;
            paramsModify['operator'] = userPref.username;
            setLoading(true);

            if(props.type === 'copy' || props.type === 'new') {
                if(type === 'publish') {
                    await handleCreatePublish(paramsModify)
                } else {
                    await handleCreate(paramsModify)
                }
            } else {
                if(type === 'publish') {
                    await handleEditPublish(paramsModify);
                } else {
                    await handleEdit(paramsModify);
                }
            }
        } catch { } finally {
            setLoading(false);
        }
    }

    const handleRecipients = (type) => {
        let typeCurr = recipientType;
        if(type) {
            typeCurr = type;
        }
        dispatch(getRecipients(typeCurr.id, userPref.userCity))
        .then((res) => {
            let recipientsModify = [];
            if(typeCurr.id === '0') {
                recipientsModify = res;
            } else {
                recipientsModify.push(RECIPIENTS_INIT);
                res.forEach(item => {
                    if(typeCurr.id === '1') {
                        if(warehouses.includes(Number(item.warehouse_id))) {
                            recipientsModify.push({
                                code: item.warehouse_id,
                                name: item.warehouse_name
                            })
                        }
                    } else if(typeCurr.id === '2') {
                        recipientsModify.push({
                            code: item.team_id,
                            name: item.group_name
                        })
                    } else {
                        recipientsModify.push({
                            code: item.driver_id + '',
                            name: item.driver_id + ''
                        })
                    }
                });
            }
            setRecipients(recipientsModify);
        })
        .finally(() => {
            setLoading(false);
        })
    }

    const handleAssignRecipients = async() => {
        try {
            let recipientsClone = [];
            await props.detail.recipients.forEach((recipient) => {
                recipientsClone.push(
                    {
                        code: Number(recipient.id),
                        name: recipient.name
                    }
                )
            })
            setRecipientsSelected(recipientsClone);
            setRecipientType({id: props.detail.recipient_type + '', isInitialEdit: true});
            await handleRecipients({id: props.detail.recipient_type + '', isInitialEdit: true});
        } catch {} finally {}
    }
    
    useEffect(() => {
        if(props.open) {
            // '0' -> all
            // '1' -> warehouse
            // '2' -> group
            // '3' -> individual
            if(!recipientType.isInitialEdit) {
                setLoading(true);
                setRecipientsSelected([]);
                handleRecipients();
            }
        }
    }, [recipientType, props.open])

    useEffect(() => {
        if(props.open) {
            setParams(PARAMS_INIT);
            if(props.type === 'edit' || props.type === 'copy') {
                let clone = {};
                handleAssignRecipients();
                for (const key in props.detail) {
                    if(key === 'effective_to') {
                        clone[key] = moment(Number(moment(props.detail[key]).unix())*1000).format('YYYY-MM-DD HH:mm:ss');
                    } else if(key === 'prompts_mode') {
                        clone['prompts_mode'] = props.detail[key];
                    } else {
                        clone[key] = props.detail[key];
                    }
                }
                setParams(clone);
            }
        }
    }, [props.open])

    return (
        <UniDialog
            title={(props.type === 'new' || props.type === 'copy') ? t('new_message') : (props.messageGeneralType === 'drafts' ? t('edit_draft') : t('edit_message'))}
            maxWidth='md'
            open={props.open}
            onClose={props.onClose}
            fullWidth={true}
            buttons={[
                {
                    color: 'primary',
                    text: t('draft'),
                    action: () => handleUpdate('create'),
                    style: 'contained',
                    disabled: !params.title || !params.content || !recipientsSelected.length > 0 || (props.messageGeneralType === 'effective' && props.type === 'edit'),
                    id: 'messagecenter-createdraft-button'
                },
                {
                    color: 'primary',
                    text: t('publish'),
                    action: () => handleUpdate('publish'),
                    style: 'contained',
                    disabled: !params.title || !params.content || !recipientsSelected.length > 0,
                    id: 'messagecenter-savepublish-button'
                }
            ]}
        >
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <TextField
                        label={t('message_type_star')}
                        select
                        fullWidth
                        variant="outlined"
                        value={params.message_type}
                        onChange={(e) => setParams((prev) => ({
                            ...prev,
                            'message_type': e.target.value
                        }))}
                    >
                        {
                            messageTypes?.map((message) => (
                                <MenuItem value={message.code}>{message.name}</MenuItem>
                            ))
                        }
                    </TextField>
                </Grid>
                {
                    params.message_type === 1 ?
                    <Grid container item xs={8}></Grid>
                    :
                    <Grid container item xs={8} spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                label={t('date_to_star')}
                                type="datetime-local"
                                fullWidth
                                variant="outlined"
                                value={params.effective_to}
                                onChange={(e) => setParams((prev) => ({
                                    ...prev,
                                    'effective_to': moment(e.target.value).format("YYYY-MM-DD HH:mm:ss")
                                }))}
                            />
                        </Grid>
                    </Grid>
                }
                <Grid item xs={4}>
                    <TextField
                        label={t('recipient_group_star')}
                        select
                        fullWidth
                        variant="outlined"
                        value={recipientType.id}
                        onChange={(e) => setRecipientType({id:e.target.value,isInitialEdit:false})}
                    >
                        {
                            recipientGroup?.map((group) => (
                                group.code !== '0' &&
                                <MenuItem value={group.code}>{group.name}</MenuItem>
                            ))
                        }
                    </TextField>
                </Grid>
                <Grid item xs={8}>
                    <Autocomplete
                        id='messagecenter-messagerecipients-autocomplete'
                        multiple
                        options={recipients || []}
                        getOptionLabel={recipient => recipient.name}
                        filterSelectedOptions
                        limitTags={1}
                        onChange={(event, value) => {
                            if(value.length) {
                                let isAll = false;
                                value.forEach(item => {
                                    if(item.code === RECIPIENTS_INIT.code) {
                                        isAll = true;
                                        return;
                                    }
                                });
                                if(isAll) {
                                    setRecipientsSelected([RECIPIENTS_INIT]);
                                    return;
                                }
                            }
                            setRecipientsSelected(value);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                label={t('recipient_star')}
                            />
                        )}
                        fullWidth
                        value={recipientsSelected}
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField
                        label={t('enable_option_star')}
                        select
                        fullWidth
                        variant="outlined"
                        value={params.prompts_mode}
                        onChange={(e) => setParams((prev) => ({
                            ...prev,
                            'prompts_mode': e.target.value
                        }))}
                    >
                        {
                            // prompList?.map((prompt) => (
                            //     <MenuItem value={prompt.code}>{prompt.name}</MenuItem>
                            // ))
                            prompList?.length > 0 &&
                            <MenuItem value={prompList[1].code}>{prompList[1].name}</MenuItem>
                        }
                    </TextField>
                </Grid>
                <Grid item xs={8}>
                    <TextField
                        label={t('title_star')}
                        fullWidth
                        variant="outlined"
                        value={params.title}
                        onChange={(e) => setParams((prev) => ({
                            ...prev,
                            'title': e.target.value
                        }))}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label={t('content_star')}
                        fullWidth
                        multiline
                        rows={6}
                        variant="outlined"
                        value={params.content}
                        onChange={(e) => setParams((prev) => ({
                            ...prev,
                            'content': e.target.value
                        }))}
                    />
                </Grid>
            </Grid>
            <FullscreenLoading open={loading}/>
        </UniDialog>
    );
}
export default MessageDetail;